import React, { Component } from "react";

import "react-bootstrap";
import { connect } from "react-redux";

import store from "../../store/configureStore";
import { lang } from "../../config/lang";
import { changeActiveItemAction } from "../../actions/navAction";
import { Businesses, PagesForCaption, CaptionCodes } from "../../config/Helper";
import * as apiConstant from "../../api/apiConstant";
import envApi from "../../api/envApi";
import captionApi from "../../api/captionApi";
import { addNotification } from "../../actions/notificationAction";
import { changeTopBannerAction } from "../../actions/topBannerAction";
import AgencySlider from "../../components/agency/AgencySlider";
import ScrollToTop from "../home/ScrollToTop/ScrollToTop";
import * as UTILS from "../../config/utils";

class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            aboutInfo: {},
            sectionTitle: {},
        };

        this.getSectionTitles = this.getSectionTitles.bind(this);
        this.getAboutInfo = this.getAboutInfo.bind(this);
    }

    componentWillMount() {
        store.dispatch(changeActiveItemAction(Businesses.indexOf("about")));
        store.dispatch(
            changeTopBannerAction({
                page: "about",
                showSearch: false,
                isHome: false,
            })
        );
    }

    componentDidMount() {
        window.onSetClass("light");
        window.onClose();
        window.scrollTop("#top_banner");
        this.getAboutInfo();
        this.getSectionTitles();
    }

    componentDidUpdate() {
        window.onClose();
    }

    componentWillUnmount() {}

    componentWillReceiveProps(newProps) {
        this.getAboutInfo();
        this.getSectionTitles();
    }

    getSectionTitles() {
        captionApi.getCaptions("about").then((json) => {
            if (json.status === 200) {
                this.setState({
                    sectionTitle: json.data,
                });
                window.contentWayPoint();
            } else {
                // store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
            }
        });
    }

    getAboutInfo() {
        envApi.getAboutInfo().then((json) => {
            if (json.status === 200 && json.data) {
                this.setState({
                    aboutInfo: json.data,
                });
            } else {
                store.dispatch(
                    addNotification(`${lang("server_err")}`, "error")
                );
            }
        });
    }

    render() {
        return (
            <div>
                <div className="about_story">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {this.state.aboutInfo.logo !== undefined &&
                                    this.state.aboutInfo.logo !== null &&
                                    this.state.aboutInfo.logo !== "" && (
                                        <div className="icon d-flex justify-content-center align-items-center pb-5">
                                            <div className="org-logo d-flex justify-content-center align-items-center">
                                                <img
                                                    src={apiConstant.orgMarkURL(
                                                        this.state.aboutInfo
                                                            .logo
                                                    )}
                                                    alt="about-mark-url"
                                                    id="img_org_mark"
                                                />
                                            </div>
                                        </div>
                                    )}
                                <div className="heading-section ftco-animate">
                                    <h2 className="mb-4 pb-3">
                                        {this.state.sectionTitle[
                                            CaptionCodes[
                                                PagesForCaption.indexOf("about")
                                            ].indexOf("about_org")
                                        ] === undefined
                                            ? ""
                                            : this.state.sectionTitle[
                                                  CaptionCodes[
                                                      PagesForCaption.indexOf(
                                                          "about"
                                                      )
                                                  ].indexOf("about_org")
                                              ].title}
                                    </h2>
                                </div>
                                <div className="row">
                                    <div className="col-lg-10 offset-lg-1">
                                        <div className="story_info">
                                            <div className="row">
                                                <div className="col-lg-12 ftco-animate">
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: this.state
                                                                .aboutInfo
                                                                .description,
                                                        }}
                                                    />
                                                    <p>
                                                        <b>
                                                            {lang("address")}:
                                                        </b>{" "}
                                                        {
                                                            this.state.aboutInfo
                                                                .others
                                                        }
                                                    </p>

                                                    <p>
                                                        <b>{lang("tel")}:</b>{" "}
                                                        {
                                                            this.state.aboutInfo
                                                                .phone
                                                        }
                                                    </p>
                                                    <p>
                                                        <b>{lang("fax")}:</b>{" "}
                                                        {
                                                            this.state.aboutInfo
                                                                .fax
                                                        }
                                                    </p>
                                                    <p>
                                                        <b>{lang("email")}:</b>{" "}
                                                        {
                                                            this.state.aboutInfo
                                                                .email
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <AgencySlider
                    isPart={false}
                    title={
                        this.state.sectionTitle[
                            CaptionCodes[
                                PagesForCaption.indexOf("about")
                            ].indexOf("about_agency_list")
                        ] === undefined
                            ? ""
                            : this.state.sectionTitle[
                                  CaptionCodes[
                                      PagesForCaption.indexOf("about")
                                  ].indexOf("about_agency_list")
                              ].title
                    }
                    sub_title={
                        this.state.sectionTitle[
                            CaptionCodes[
                                PagesForCaption.indexOf("about")
                            ].indexOf("about_agency_list")
                        ] === undefined
                            ? ""
                            : this.state.sectionTitle[
                                  CaptionCodes[
                                      PagesForCaption.indexOf("about")
                                  ].indexOf("about_agency_list")
                              ].description
                    }
                />
                <ScrollToTop />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language,
    };
}

export default connect(mapStateToProps)(About);
